import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getYoutubePreviewImage, YOUTUBE_PREVIEW_SIZE } from 'client/utils/image-helpers';

import './video-preview.scss';

export function VideoPreview({
  videoId,
  videoTitle,
  videoThumbnailUrl = null,
  creativeId,
  videoAspectRatio = '16:9',
  openVideoModal,
  isStaticPos = false,
}) {
  function openVideo() {
    openVideoModal({ creativeId, videoId, videoTitle, videoAspectRatio });
  }

  return (
    <div className="video-preview h-100 w-100 pos-r">
      <div className={classnames('preview-image', { 'static-pos': isStaticPos })}>
        <img
          className="placeholder-img w-100"
          src={videoThumbnailUrl || getYoutubePreviewImage(videoId, YOUTUBE_PREVIEW_SIZE.HQ)}
          alt={videoTitle}
        />
      </div>
      <button className="loader w-100 h-100 p-0 border-0" onClick={openVideo} aria-label={videoTitle} />
    </div>
  );
}

VideoPreview.propTypes = {
  openVideoModal: PropTypes.func.isRequired,
  videoId: PropTypes.string.isRequired,
  videoTitle: PropTypes.string.isRequired,
  creativeId: PropTypes.string.isRequired,
  videoThumbnailUrl: PropTypes.string,
  videoAspectRatio: PropTypes.string,
  isStaticPos: PropTypes.bool,
};
